import { Component, Input, OnChanges } from '@angular/core'

import { Agrupamento } from '../../../pkw-data/collect/extrato/agrupamento.model'
import { Venda } from '../../../pkw-data/collect/extrato/venda.model'
import { FiltroExtrato } from '../../shared/filtro-extrato'

@Component({
  selector: 'col-detalhe-estabelecimentos',
  templateUrl: './detalhe-estabelecimentos.component.html',
  styleUrls: ['../../extratos.component.scss']
})
export class DetalheEstabelecimentosComponent implements OnChanges {

  @Input() agrupamento: Agrupamento<Venda>
  @Input() filtro: FiltroExtrato

  maisDetalhesExpandido: boolean[]

  constructor() {}

  ngOnChanges() {
      if (this.agrupamento) {
          this.maisDetalhesExpandido = new Array(this.agrupamento.detalhes.length)
          this.maisDetalhesExpandido.fill(false)                                
      }        
  }

  toggleCollapse(index: number, icon: HTMLSpanElement) {
      this.maisDetalhesExpandido[index] = !this.maisDetalhesExpandido[index]

      icon.classList.toggle('fa-chevron-right')
      icon.classList.toggle('fa-chevron-down')          
  }

}



// WEBPACK FOOTER //
// ./src/app/extratos/extratos-de-vendas/detalhe-estabelecimentos/detalhe-estabelecimentos.component.ts